import styled from 'styled-components';

export const Container = styled.section`
  min-height: 60vh;
  display: flex;
  align-items: center;

  display: flex;
  align-items: center;

  .inputs-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100vw;
    width: 100%;
    margin: 0 auto;
    height: 100%;
    border-radius: 1rem;
    background-color: #FFFFFF;
    background-image: none;
    @media(max-width: 1022px) {
      padding: 0rem;
    }
    Input::placeholder{
      font-size: 15px;
    }
    input[type="text"]{
      font-size: 25px;

      @media(max-width: 1022px) {
        font-size:15px;
      }
    }
    .SeguirSub{
      width: 10vw;
    }
    @media(max-width: 560px) {
      max-width: 100vw;
      padding: 0rem;
    }
    .inputs {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 4vh;
      gap: 4vw;
      
      .input-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        width: 100%;

        .check-area{
          margin-top: 2rem;
          font-size: 15px;
          color: #808080;

          Label{
            color: #000000;
          }
        }

        .input-endereco {
          width: 100%;
        }

        .check-area {
          width: 100%;
          .p {
            text: left;
          }
        }

        .input-row {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 100%;
          gap: 1vw;

          .input-city {
            width: 50%;
          }

          .input-uf {
            width: 18%;
          }

          .input-cep {
            width: 32%;
          }
        }
      }
    }
  `